import Vue from 'vue'
import Router from 'vue-router'
import { interopDefault } from './utils'
import scrollBehavior from './router.scrollBehavior.js'

const _5fa5de78 = () => interopDefault(import('../../../pages/old/App.vue' /* webpackChunkName: "" */))
const _d60320dc = () => interopDefault(import('../../../pages/old/home/home.vue' /* webpackChunkName: "" */))
const _11315e5c = () => interopDefault(import('../../../pages/old/ajkRank/xiaoqu/communityHot.vue' /* webpackChunkName: "" */))
const _e80cdc0e = () => interopDefault(import('../../../pages/old/rank/borkerRank/borkerRank.vue' /* webpackChunkName: "" */))
const _81ac6396 = () => interopDefault(import('../../../pages/old/rank/storeRank/storeRank.vue' /* webpackChunkName: "" */))
const _adda603c = () => interopDefault(import('../../../pages/old/ajkRank/qiangshou/index.vue' /* webpackChunkName: "" */))
const _5d857624 = () => interopDefault(import('../../../pages/old/wakeAPP/wakeAPP.vue' /* webpackChunkName: "" */))
const _9f656858 = () => interopDefault(import('~/layouts/non-available.vue' /* webpackChunkName: "" */))
const _7ccc3624 = () => interopDefault(import('../../../pages/captcha-wangyi/index.vue' /* webpackChunkName: "" */))
const _eebaa218 = () => interopDefault(import('../../../pages/captcha-geetest/index.vue' /* webpackChunkName: "" */))
const _247047aa = () => interopDefault(import('../../../pages/trendency/index.vue' /* webpackChunkName: "" */))
const _5342745f = () => interopDefault(import('../../../pages/old/ajkRank/synList/synList.vue' /* webpackChunkName: "" */))
const _13fe28c2 = () => interopDefault(import('../../../pages/esf-package/index.vue' /* webpackChunkName: "" */))
const _ff91bd6c = () => interopDefault(import('../../../pages/map/index.vue' /* webpackChunkName: "" */))
const _e250fc3e = () => interopDefault(import('../../../pages/agreement/carrier/index.vue' /* webpackChunkName: "" */))
const _32ef94be = () => interopDefault(import('../../../pages/weak/miniProgram/index.vue' /* webpackChunkName: "" */))
const _3f8ce9f7 = () => interopDefault(import('../../../pages/common-material/index.vue' /* webpackChunkName: "" */))
const _67840563 = () => interopDefault(import('../../../pages/samsung-download/index.vue' /* webpackChunkName: "" */))
const _6df105de = () => interopDefault(import('../../../pages/app/download/index.vue' /* webpackChunkName: "" */))
const _5fca722f = () => interopDefault(import('../../../pages/app/pano-report/index.vue' /* webpackChunkName: "" */))
const _1163bc1a = () => interopDefault(import('../../../pages/app/result/index.vue' /* webpackChunkName: "" */))
const _6222cd93 = () => interopDefault(import('~/layouts/error.vue' /* webpackChunkName: "" */))

Vue.use(Router)

export const routerOptions = {
  mode: 'history',
  base: decodeURI('/'),
  linkActiveClass: 'nuxt-link-active',
  linkExactActiveClass: 'nuxt-link-exact-active',
  scrollBehavior,

  routes: [{
    path: "/",
    component: _5fa5de78,
    alias: "/feapp",
    name: "App",
    children: [{
      path: ":city([a-z]+)/",
      component: _d60320dc,
      name: "mHome"
    }, {
      path: "ershou-autorank/xiaoqu",
      component: _11315e5c,
      name: "communityHot"
    }, {
      path: "ershou-autorank/broker",
      component: _e80cdc0e,
      name: "brokerRank"
    }, {
      path: "ershou-autorank/store",
      component: _81ac6396,
      name: "storeRank"
    }, {
      path: "ershou-autorank/fangyuan/qiangshou/*",
      component: _adda603c,
      name: "qiangshou"
    }, {
      path: "ershou-autorank/fangyuan/pinzhi/*",
      component: _adda603c,
      name: "pinzhi"
    }, {
      path: "ershou-autorank/fangyuan/*",
      component: _adda603c,
      name: "houseRank"
    }, {
      path: "/wake/app",
      component: _5d857624,
      name: "wakeApp"
    }]
  }, {
    path: "/non-available",
    component: _9f656858,
    name: "Non Available"
  }, {
    path: "/esfcommon-captcha-wy",
    component: _7ccc3624,
    name: "captcha"
  }, {
    path: "/esfcommon-captcha-geetest",
    component: _eebaa218,
    name: "captcha"
  }, {
    path: "/pcesfcommon-captcha-wy",
    component: _7ccc3624,
    name: "captcha"
  }, {
    path: "/pcesfcommon-captcha-geetest",
    component: _eebaa218,
    name: "captcha"
  }, {
    path: "/:city([a-z]+)/trendency/",
    component: _247047aa,
    name: "city-trendency"
  }, {
    path: "/:city([a-z]+)/trendency/:area_id(\\d+)_:block_id(\\d+)/",
    component: _247047aa,
    name: "block-trendency"
  }, {
    path: "/:city([a-z]+)/trendency/:area_id(\\d+)/",
    component: _247047aa,
    name: "area-trendency"
  }, {
    path: "/:city([a-z]+)/trendency/community/:comm_id",
    component: _247047aa,
    name: "community-trendency"
  }, {
    path: "/:city([a-z]+)/trendency/:area_id(\\d+)-q-:shangquan_id(\\d+)/",
    component: _247047aa,
    name: "shangquan-trendency"
  }, {
    path: "/:city([a-z]+)/trendency/:area_py(\\w+)/",
    component: _247047aa,
    name: "area-trendency"
  }, {
    path: "/:city([a-z]+)/trendency/:area_py(\\w+)-q-:shangquan_py(\\w+)/",
    component: _247047aa,
    name: "shangquan-trendency"
  }, {
    path: "/ershou-autorank/synList",
    component: _5342745f,
    name: "syn-rankList"
  }, {
    path: "/feapp/ershou-autorank/synList",
    component: _5342745f,
    name: "syn-rankList-wb"
  }, {
    path: "/ershou-autorank/common",
    component: _13fe28c2,
    name: "syn-com"
  }, {
    path: "/:city([a-z]+)/map/community",
    component: _ff91bd6c,
    name: "map"
  }, {
    path: "/xiaoqu/([a-zA-Z0-9]+)/map/community",
    component: _ff91bd6c,
    name: "mapwb"
  }, {
    path: "/agreement/carrier/:id",
    component: _e250fc3e,
    name: "agreement"
  }, {
    path: "/weak/miniProgram/esf",
    component: _32ef94be,
    name: "weakMiniProgramESF"
  }, {
    path: "/clbCfg/common/material",
    component: _3f8ce9f7,
    name: "commonMaterial"
  }, {
    path: "/clb_cfg/menu/materialtemplate/materialtemplate",
    component: _3f8ce9f7,
    name: "commonMaterialPath"
  }, {
    path: "/agreement/samsungDownload",
    component: _67840563,
    name: "samsungDownload"
  }, {
    path: "/esfcommon/app/download",
    component: _6df105de,
    name: "appDownload"
  }, {
    path: "/esfcommon/app/pano-report",
    component: _5fca722f,
    name: "panoReport"
  }, {
    path: "/esfcommon/app/result",
    component: _1163bc1a,
    name: "panoReportResult"
  }, {
    path: "*",
    component: _6222cd93,
    name: "Not Found"
  }],

  fallback: false
}

export function createRouter () {
  return new Router(routerOptions)
}
